import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const scrollToPageTop = () => {
  if (typeof window === 'undefined') {
    return;
  }

  window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;
};

const ScrollToTop = () => {
  const { pathname, search } = useLocation();

  useEffect(() => {
    scrollToPageTop();
  }, [pathname, search]);

  return null;
};

export default ScrollToTop;
